module.exports = __webpack_public_path__ + "static/img/6.1f08d36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/22/6.png
// module id = GnSm
// module chunks = 0